import styled from 'styled-components';

const InputContainer = styled.div`
  min-height: 64px;
  display: grid;
  gap: ${({ theme }) => theme.spacing.S8};
  grid-template-columns: 106px 1fr;
`;

export { InputContainer };
